import { render } from "./carrosselUrl.vue?vue&type=template&id=a053e1c0"
import script from "./carrosselUrl.vue?vue&type=script&lang=js"
export * from "./carrosselUrl.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\musta\\Área de Trabalho\\Projetos\\catalogo\\catalogo-pedidos\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__